import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { useTranslation } from 'react-i18next';
import Select from '@material-ui/core/Select';
import es from 'date-fns/locale/es';
import api from "./components/Config/HttpFeasibility";
import TimetableIcon from 'mdi-react/TimetableIcon';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ListActions from './components/ListFeasibility/ListActions';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import renderSelectField from '../../shared/components/form/Select';
import ListFeasibility from './components/ListFeasibility/List';
import { Field, reduxForm } from 'redux-form';
import Modal from '../../shared/components/Modal';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const Feasibility = ({ history, location }) => {
    const { t } = useTranslation('common');

    const [allSponsors, setAllSponsors] = React.useState([]);
    const [optionsSponsors, setOptionsSponsors] = React.useState([]);
    const [sponsor, setSponsor] = React.useState(null);
    const [acronym, setAcronym] = React.useState(null);
    const [date, setDate] = React.useState(null);
    const [dateFormat, setDateFormat] = React.useState(null);
    const [state, setState] = React.useState(null);
    const [list, setList] = React.useState([]);

    const [showModal, setShowModal] = React.useState(false);
    const [messageModal, setMessageModal] = React.useState(null);
    const [colorModal, setColorModal] = React.useState("success");

    const validateSponsor = () => {
        let _acronym = acronym == null || acronym.length < 1;

        if (sponsor == null) {
            return true;
        } else {
            if (sponsor.length >= 1 && _acronym) {
                openModal(false, t('msg.sponsor_and_acronym_require'));
                return false;
            } else {
                return true;
            }
        }
    }

    const validateCriteria = () => {
        let _sponsor = sponsor == null || sponsor.length < 1;
        let _acronym = acronym == null || acronym.length < 1;
        let _date = date == null || date.length < 1;
        let _state = state == null || state === 0;

        if (_sponsor && _acronym && _date && _state) {
            getFeasibility();
        } else {
            return true;
        }
    }

    const validate = async () => {
        if (validateCriteria()) {
            if (validateSponsor()) {
                sendRequest();
            }
        }
    }

    const sendRequest = async () => {
        let _params = {
            "id_patrocinador": sponsor,
            "acronimo": acronym,
            "fecha": dateFormat,
            "estado": state
        };

        let _data = await api.searchFeasibility(_params);
        if (_data.existe) {
            setList(_data.contenido);
        } else {
            openModal(false, _data.contenido);
            //setList([]);
        }
    }

    const AllRow = () => {
        let _row = [];
        let _url = "/clinical-studio/confidentiality";

        return (
            <Row>
                <Col >
                    <ListFeasibility title="Factibilidad" reactTableData={list} ReactTableActions={ListActions} />
                </Col>
            </Row>
        );
    }

    const getFeasibility = async () => {
        let _data = await api.listFeasibility();

        if (_data.existe) {
            setList(_data.contenido);
        }
        else {
            setList([]);
        }

    }

    const listSponsors = async (data) => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/listar_patrocinadores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setAllSponsors(data);
            SponsorList(data);
        }).catch((error) => {
            setAllSponsors([]);
        });
    }

    const SponsorList = (data) => {
        let _rows = [];
        data.forEach(sponsor => {
            _rows.push({ value: sponsor.id_tercero, label: sponsor.nombre });
        });
        setOptionsSponsors(_rows);
    }

    const handlerSponsor = (value) => {
        setSponsor(value);
    }

    const handlerDate = (value) => {
        if (value != null) {
            let fecha_seleccionada = moment(value).format('YYYY/MM/DD');
            setDate(date);
            setDateFormat(fecha_seleccionada);
        }
        else {
            setDate(null);
            setDateFormat(null);
        }
    }

    const openModal = (success, message) => {
        if (success == true) {
            setColorModal("success");
        }
        else {
            setColorModal("danger");
        }
        setShowModal(true);
        setMessageModal(message);
    }

    useEffect(() => {
        listSponsors();
        getFeasibility();
    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Estudios Clinicos</h3>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">{t('feasibility.search_criteria')}</h5>
                        <h5 className="subhead">Ingresa uno de los criterios para realizar la búsqueda.</h5>
                    </div>

                    <Row>

                        <Col md={3}>
                            <TextField
                                label="Patrocinador"
                                value={sponsor}
                                onChange={(event) => {
                                    handlerSponsor(event.target.value)
                                }}
                                select
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            >
                                {optionsSponsors.map((item, index) => {
                                    return (<MenuItem key={item.value} value={item.value}>
                                        {item.label}
                                    </MenuItem>)
                                })}
                            </TextField>
                        </Col>
                        <Col md={3}>
                            <TextField
                                label="Acronimo"
                                value={acronym}
                                onChange={(event) => {
                                    setAcronym(event.target.value);
                                }}
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <ThemeProvider theme={defaultMaterialTheme}>
                                    <DatePicker
                                        disableFuture
                                        openTo="date"
                                        label="Fecha Inicial"
                                        variant="inline"
                                        autoOk={true}
                                        views={["year", "month", "date"]}
                                        value={date}
                                        onChange={(value) => {
                                            handlerDate(value);
                                        }}
                                        className='medical-material-form__field'
                                        animateYearScrolling
                                        format="yyyy/MM/D"
                                    />
                                </ThemeProvider>
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={3}>
                            <TextField
                                label="Estado"
                                value={state}
                                onChange={(event) => {
                                    setState(event.target.value);
                                }}
                                select
                                style={{ minWidth: '100%', maxWidth: '100%' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            >
                                <MenuItem key={1} value={1}>
                                    EN PROCESO
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    ACEPTADA
                                </MenuItem>
                                <MenuItem key={3} value={3}>
                                    NO ACEPTADA
                                </MenuItem>
                                <MenuItem key={4} value={4}>
                                    FINALIZADA
                                </MenuItem>
                            </TextField>
                        </Col>
                        <Col md={12}>
                            <br />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 30 }}>
                                <Button
                                    style={{ marginTop: 10 }}
                                    variant="contained"
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => {
                                        validate();
                                    }}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    style={{ marginTop: 10 }}
                                    variant="contained"
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => {
                                        history.push(process.env.PUBLIC_URL + "/clinical-studio/add")
                                    }}
                                >
                                    Agregar
                                </Button>
                            </div>
                            <br />

                            <div>

                                {list.length > 0 && <AllRow />}
                            </div>

                        </Col>
                    </Row>

                    <Modal
                        color={colorModal}
                        title={messageModal}
                        modal={showModal}
                        onOk={() => setShowModal(false)}
                        toggle={() => setShowModal(false)}
                    />

                </CardBody>
            </Card>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_feasibility', // a unique identifier for this form
})(Feasibility);